// extracted by mini-css-extract-plugin
export default {"activitiesSection":"ClientDetailsPage_activitiesSection__Jo9d5"};